import {
  reactive, ref, watch, toRef,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'
import { errorNotification } from '@/utils/toast-notifications'
import { tripStatusFormatter } from '@/views/trips/hooks/tripStatusUtils'

export default function useDriverUserTrips(props, ctx) {
  const loading = ref(false)
  const personId = ctx.root.$route.query.externalId
  const tableColumns = [
    { key: 'number', label: 'trip number' },
    {
      key: 'createdAt',
      label: 'created at',
      formatter: value => formatDate(value),
    },
    {
      label: 'Rider',
      key: 'userDetails',
      formatter: val => `${val?.first_name} ${val?.last_name}`,
    },
    {
      label: 'Driver',
      key: 'driver',
      formatter: val => val && `${val.first_name} ${val.last_name}`,
    },
    {
      label: 'Driver id',
      key: 'driverId',
    },
    {
      label: 'Zone',
      key: 'zone',
      formatter: val => val?.split('::')[1],
    },
    {
      label: 'Type',
      key: 'className',
    },
    {
      label: 'status',
      key: 'state',
      formatter: val => tripStatusFormatter(val),
    },
  ]

  const stateOptions = [
    {
      label: 'All',
      key: 'ALL',
    },
    {
      label: 'Completed',
      key: 'COMPLETED',
    },
    {
      label: 'Created',
      key: 'CREATED',
    },
    {
      label: 'Canceled',
      key: 'CANCELED',
    },
    {
      label: 'Accepted',
      key: 'ACCEPTED',
    },
    {
      label: 'Arrived',
      key: 'ARRIVED',
    },
    {
      label: 'In progress',
      key: 'IN_PROGRESS',
    },
    {
      label: 'Looking for driver',
      key: 'LOOKING_FOR_DRIVER',
    },
    {
      label: 'No driver found',
      key: 'NO_DRIVER_FOUND',
    },
  ]
  const tripsList = ref([])
  const totalTrips = ref(0)
  const tempTime = new Date()

  const dateTimeFilter = reactive({
    fromDate: `${tempTime.getFullYear()}-${tempTime.getMonth() + 1}-${tempTime.getDate()}`,
    fromTime: undefined,
    toDate: `${tempTime.getFullYear()}-${tempTime.getMonth() + 1}-${tempTime.getDate()}`,
    toTime: undefined,
  })
  const tripId = ref()
  const queryParams = reactive({
    size: 10,
    page: 1,
    user_id: props.type === 'user' ? personId : undefined,
    driver_id: props.type === 'driver' ? personId : undefined,
    state: undefined,
    user_phone: undefined,
    driver_phone: undefined,
    trip_id: undefined,
  })
  const currState = ref('ALL')
  const filterUserNumber = ref('')
  const setFilterDateFormat = () => {
    if (dateTimeFilter.fromDate) {
      if (!dateTimeFilter.fromTime) {
        queryParams.from = new Date(`${dateTimeFilter.fromDate} 00:00:00`)
      } else {
        queryParams.from = new Date(`${dateTimeFilter.fromDate} ${dateTimeFilter.fromTime}`)
      }
    }
    if (dateTimeFilter.toDate) {
      if (dateTimeFilter.fromDate) {
        if (!dateTimeFilter.toTime) {
          const now = new Date()
          queryParams.to = new Date(`${dateTimeFilter.toDate} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`)
        } else {
          queryParams.to = new Date(`${dateTimeFilter.toDate} ${dateTimeFilter.toTime}`)
        }
        return true
      }
      errorNotification('You should fill the from date and time first')
      return false
    }
    return true
  }

  const fetchTripsList = async () => {
    try {
      const val = setFilterDateFormat()
      if (!val) return
      loading.value = true
      if (currState.value === 'ALL') {
        queryParams.state = undefined
      } else {
        queryParams.state = currState.value
      }
      if (props.type === 'driver') {
        if (filterUserNumber.value) {
          queryParams.user_phone = filterUserNumber.value
        } else {
          queryParams.user_phone = undefined
        }
      } else if (filterUserNumber.value) {
        queryParams.driver_phone = filterUserNumber.value
      } else {
        queryParams.driver_phone = undefined
      }
      if (tripId.value) {
        queryParams.trip_id = tripId.value
      } else {
        queryParams.trip_id = undefined
      }
      const res = await ctx.root.$store.dispatch('driverUsersTrips/fetchDriverUserTripsList', queryParams)
      const { trips, total } = res.data.data
      tripsList.value = trips.map(trip => ({
        ...trip,
        driverId: trip.driver ? trip.driver.driver_id : undefined,
      }))
      totalTrips.value = total
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
  const applySearch = () => {
    queryParams.page = 1
    fetchTripsList()
  }
  const clearFilter = () => {
    currState.value = 'ALL'
    queryParams.state = undefined
    dateTimeFilter.fromDate = undefined
    dateTimeFilter.toDate = undefined
    dateTimeFilter.fromTime = undefined
    dateTimeFilter.toTime = undefined
    queryParams.from = undefined
    queryParams.to = undefined
    filterUserNumber.value = undefined
    queryParams.trip_id = undefined
    tripId.value = undefined
    fetchTripsList()
  }
  fetchTripsList()
  watch([toRef(queryParams, 'size')], () => {
    fetchTripsList()
  })
  // const canSearch = computed(() => filterUserNumber.value || tripId.value)
  return {
    // canSearch,
    applySearch,
    tableColumns,
    fetchTripsList,
    tripsList,
    loading,
    totalTrips,
    stateOptions,
    queryParams,
    dateTimeFilter,
    clearFilter,
    currState,
    filterUserNumber,
    tripId,
  }
}
